<template>
  <div style="display: none;">
    <slot v-if="ready"></slot>
  </div>
</template>

<script>
import 'leaflet.markercluster'
import ColorMixin from '../../plugins/mixins/ColorMixin'

import { findRealParent, propsBinder, L } from 'vue2-leaflet'

const props = {
  options: {
    type: Object,
    default() { return {}; },
  },
};

export default {
  props,
  mixins: [ ColorMixin ],
  data() {
    return {
      ready: false,
      useUserDefinedColorMode: true
    };
  },
  mounted() {
    this.mapObject = L.markerClusterGroup({...this.options, 'iconCreateFunction': this.createClusterIcon});
    L.DomEvent.on(this.mapObject, this.$listeners);
    propsBinder(this, this.mapObject, props);
    this.ready = true;
    this.parentContainer = findRealParent(this.$parent);
    this.parentContainer.addLayer(this);
  },
  beforeDestroy() {
    this.parentContainer.removeLayer(this);
  },
  methods: {
    createClusterIcon(cluster){
        
        let _info = this.getClusterInfo(cluster)
        let info = _info.statusInfo;
        let colorInfo = _info.colorInfo;

        info = (!this.useUserDefinedColorMode) ? info : colorInfo;

        let gradientStops = this.getPercentageStops(info, this.useUserDefinedColorMode)        
        let background = `background: conic-gradient(`;
        for(const [i,ele] of gradientStops.entries()) {        
          background += `${ele.color} ${ele.start}% ${ele.end}% `
          if(ele.type != "ERROR" && i < gradientStops.length - 1){
            background += ', '
          }
        }
        background += ') !important;'  
        
        // fall back for non conic, do linear
        let fb_background = `linear-gradient(90deg, `;
        for(const [i,ele] of gradientStops.entries()) {        
          fb_background += `${ele.color} ${ele.start}% ${ele.end}% `
          if(ele.type != "ERROR" && i < gradientStops.length - 1){
            fb_background += ', '
          }
        }
        fb_background += ');'  
        
        let allBg = `background: ${fb_background} background: -ms-${fb_background} background: -o-${fb_background}`

        background = `${background} ${allBg}`

        
        return L.divIcon({html: `<div class="dd-cluster" style="${background}"><div class="dd-inner-cluster">${cluster.getChildCount()}</div></div>`})
      
    },
    getPercentageStops(info, colorMode){
      let stops  = []     
      if(!colorMode){
        let total = info.total.error + info.total.actionOnError + info.total.warning + info.total.action + info.total.ok      
         
        let prevPerc = 0        

        if(info.total.ok > 0){
          let perc = Math.round((info.total.ok / total) * 100);
          
          stops.push({start: prevPerc, end: (prevPerc + perc), type: 'OK', color: this.successColor})
          prevPerc = prevPerc + perc
        }
        if(info.total.action > 0){
          let perc = Math.round((info.total.action / total) * 100);
          stops.push({start: prevPerc, end: (prevPerc + perc), type: 'ACTION', color: this.actionColor})
          prevPerc = prevPerc + perc
        }
        if(info.total.warning > 0){
          let perc = Math.round((info.total.warning / total) * 100);
          stops.push({start: prevPerc, end: (prevPerc + perc), type: 'WARNING', color: this.warningColor})
          prevPerc = prevPerc + perc
        }
        if(info.total.actionOnError > 0){
          let perc = Math.round((info.total.actionOnError / total) * 100);
          stops.push({start: prevPerc, end: (prevPerc + perc), type: 'ERROR_WITH_ACTION', color: this.errorWithActionColor })
          prevPerc = prevPerc + perc
        }
        if(info.total.error > 0){
          let perc = Math.round((info.total.error / total) * 100);
          stops.push({start: prevPerc, end: (prevPerc + perc), type: 'ERROR', color: this.errorColor})                  
        }

      }
      else{
        
        let prevPerc = 0           
        let total = 0      
        for(let [i,ele] of Object.entries(info)){          
          total += ele
        }
        
        for(let [color,count] of Object.entries(info)){          
          let perc = Math.round((count / total) * 100);
          
          stops.push({start: prevPerc, end: (prevPerc + perc), type: 'UD', color: color})
          prevPerc = prevPerc + perc
        }

      }
      
      return stops;

    },
    getClusterInfo(cluster){
      let markers = cluster.getAllChildMarkers()
      let info = {
        //groups: [],
        total: {
          error: 0,
          actionOnError: 0,
          warning: 0,
          action: 0,
          ok: 0
        }
      }

      let colorInfo = {
        
      }

      markers.forEach((ele) => {
        //console.log(ele)
        colorInfo[ele.options.icon.options.data.color] = (colorInfo[ele.options.icon.options.data.color]) ? colorInfo[ele.options.icon.options.data.color] + 1 : 1
        switch(ele.options.icon.options.data.status) {
          case "ERROR": 
            info.total.error++
            break;
          case "ERROR_WITH_ACTION": 
            info.total.actionOnError++
            break;
          case "WARNING": 
            info.total.warning++
            break;
          case "ACTION": 
            info.total.action++
            break;
          case "OK": 
            info.total.ok++
            break;
        }

        
      })
      
      // let markersData = markers.map((ele) => { 
      //   return { id: ele.options.icon.options.data.id, status: ele.options.icon.options.data.status, group: ele.options.icon.options.data.group }
      //  })
      
      return { statusInfo: info, colorInfo: colorInfo };
    },
    addLayer(layer, alreadyAdded) {
      if (!alreadyAdded) {
        this.mapObject.addLayer(layer.mapObject);
      }
    },
    removeLayer(layer, alreadyRemoved) {
      if (!alreadyRemoved) {
        this.mapObject.removeLayer(layer.mapObject);
      }
    },
  },
};
</script>
<style>
.dd-cluster{
  /* background: radial-gradient(rgba(255,255,255,0.8) 30%, transparent 31%), conic-gradient(#FF5722 0% 35%, #FFEB3B 35% 60%, #2196F3 60% 100%); */
  
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}

.dd-inner-cluster{
  height: 26px;
  width: 26px;
  background-color: rgba(0,0,0,0.4);
  color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-weight: 600;
  font-family: 'roboto';
}
</style>